import React, { RefCallback } from 'react'
import { Step } from 'react-joyride'

import CloseButton from '../CloseButton/CloseButton'
import PrimaryButton from '../PrimaryButton/PrimaryButton'
import TutorialPagination from '../TutorialPagination/TutorialPagination'
import BackButton from '../BackButton/BackButton'
import Intro from '../Intro/Intro'
import Spacer from '../../common/spacer/Spacer'
import useTutorialSettings from '../TutorialSettingsProvider/useTutorialSettings'
import { TutorialElementProps } from '../Tutorial/Tutorial'

import styles from './TutorialTooltip.module.scss'

export type TooltipProps = {
  'aria-modal': boolean
  'ref': RefCallback<HTMLElement>
  'role': string
}

export type TutorialTooltipProps = {
  step: Step
  closeProps: TutorialElementProps
  tooltipProps: TooltipProps
  primaryProps: TutorialElementProps
  backProps: TutorialElementProps
  index: number
  size: number
}

const TutorialTooltip = ({
  step,
  closeProps,
  tooltipProps,
  primaryProps,
  backProps,
  index = 0,
  size = 0,
}: TutorialTooltipProps) => {
  const { tutorialSettings } = useTutorialSettings()

  if (tutorialSettings.stepIndex === 0) {
    return (
      <Intro
        step={step}
        closeProps={closeProps}
        tooltipProps={tooltipProps}
        primaryProps={primaryProps}
        index={index}
        size={size}
      />
    )
  }

  return (
    <div className={styles.tooltip} {...tooltipProps}>
      <CloseButton
        closeProps={closeProps}
        className={styles.closeButton}
        iconSize="small"
      />
      <div className={styles.content}>{step.content}</div>
      <Spacer style={{ width: '100%', height: '11px' }} />
      <PrimaryButton primaryProps={primaryProps} />
      <Spacer style={{ width: '100%', height: '11px' }} />
      <div className={styles.backButtonWithPagination}>
        <BackButton backProps={backProps} />
        <TutorialPagination activeItemIndex={index} size={size} />
        <Spacer style={{ width: '20px', height: '20px' }} />
      </div>
    </div>
  )
}

export default TutorialTooltip
